import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import MenuIcon from '@rsuite/icons/Menu';
import GridIcon from '@rsuite/icons/Grid';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import { useNavigate } from 'react-router-dom';
import SortUpIcon from '@rsuite/icons/SortUp';
import globalIP from '../../../GlobelIP';
import LoadingBar from 'react-top-loading-bar';
import { useInView } from 'react-intersection-observer';
import ImageIcon from '@rsuite/icons/Image';
import {
  Input,
  InputGroup,
  Table,
  Button,
  ButtonGroup,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Modal,
  Col,
  ButtonToolbar,
  FlexboxGrid,
  Tooltip,
  IconButton,
  Whisper,
  Loader,
  SelectPicker,
  Message,
  useToaster,
  Checkbox
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import SmartSearchModal from './smart-search-modal';
import NavD from './NavD';
import ugr from '@/UGRoute';
import {
  fetchColors,
  fetchFinishes,
  fetchHsn,
  fetchMaterials,
  fetchCategory,
  fetchAlias,
  fetchSkuUnique,
  fetchBuyers,
  fetchMadeBy,
  fetchHeads,
  fetchProductLabel,
  fetchProductDesign,
  fetchProductName,
  fetchSearchKeyword,
  fetchProductTypes
} from '../../../apiService/apiService';
import FilterDrawer from '@/components/FilterDrawer';
import HeaderFilter from '@/components/HeaderFilter';
import ProductCard from '@/components/ProductSearchPage/ProductCard';
import useFilter from '../members/Filters';
import useUser from '../../../components/UseUser';
import { Dropdown } from 'antd';
import { EyeFilled } from '@ant-design/icons';
import { Delete, TrashIcon } from 'lucide-react';
interface RowData {
  id: string; // or number, depending on your data
  attributes: {
    CategoryCode: string;
    ProductTypeCode: string;
    ProductCode: string;
    ProductId: string;
    ProductName: string;
    Description: string;
    SizeUnit: 'Inch';
    Length: 0;
    Width: 0;
    Height: 0;
    FinishCode: null;
    ColorCode: null;
    NetWeight: 0;
    GrossWeight: 0;
    HSNCode: string;
    SellingPriceCurrency: string;
    SellingPriceUnit: string;
    SellingPrice: 0;
    ProductCost: 0;
    SearchKeyword: string;
    MOQ: string;
    ProductDesigner: null;
    MadeBy: null;
    CategoryName: string;
    ProductTypeName: null;
    cbm: null;
    FinishName: null;
    ColorName: null;
    BuyerName: null;
    BuyerSku: null;
    SizeRange: null;
    Total_CBM: null;
    Total_CFT: null;
    TwentyFT: null;
    FortyFT: null;
    FortyHQ: null;
    Variant_Id: string;
    Variant: boolean;
    CoverImage: {
      data: {
        attributes: {
          url: string;
          // Add other properties of CoverImage if needed
        };
      };
    };
    MultipleImage: {
      data: {
        attributes: {
          url: string;
          // Add other properties of CoverImage if needed
        };
      };
    };
    ProductionDetail: [
      {
        id: string;
        ProductCode: string;
        MaterialNm: string;
        MaterialFinishNm: string;
        MatNetWeight: 0;
        MaterialCode: string;
        MaterialFinishCode: string;
      }
    ];
    // Add other attributes if needed
  };
}

interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}
const { HeaderCell, Cell } = Table;

const DataTable = ({ activeKey, handleNavSelect, label, isVariant }) => {
  const { user } = useUser();
  const ipp = globalIP;
  // const [data, setData] = React.useState(defaultData);
  const [data123, setData123] = useState<RowData[]>([]);
  const [meta123, setMeta123] = useState<MetaData>();
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState([]);
  const [selectedColor, setSelectedColor] = useState([]);
  const [selectedFinish, setSelectedFinish] = useState([]);
  const [selectedhsn, setSelectedhsn] = useState([]);
  const [selectedmaterial, setSelectedmaterial] = useState([]);
  const [selectedBuyer, setSelectedBuyer] = useState([]);
  const [selectedSearch, setSelectedSearch] = useState([]);
  const [selectedAlias, setSelectedAlias] = useState([]);
  const [selectedpron, setSelectedPron] = useState([]);
  const [selectedpd, setSelectedProd] = useState([]);
  const [selectedmade, setSelectedMade] = useState([]);
  const [selectedsku, setSelectedSku] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [editedData, setEditedData] = useState<Record<string, Partial<RowData['attributes']>>>({});
  const [currentPage, setCurrentPage] = useState(1);
  const [progress, setProgress] = useState(0);
  const [isLoadingTableData, SetIsLoadingTableData] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [reload, setReload] = useState(false);
  const [smartSerachModalOpen, setSmartSerachModalOpen] = useState(false);
  const [stopInfininitescrol, setStopInfininitescrol] = useState(true);
  const [loading, setLoading] = useState(false);

  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [selectedUpdatedDateRange, setSelectedUpdatedDateRange] = useState(null);
  const handleDatechange = value => {
    setCurrentPage(1)
    setData123([]);
    setSelectedDateRange(value);
  };
  const handleUpdatedDatechange = value => {
    setCurrentPage(1)
    setData123([]);
    setSelectedUpdatedDateRange(value);
  };

  const { ref, inView } = useInView({
    rootMargin: `0px 0px ${700}px 0px`
  });

  // let setSearchQryBtn = false;
  const [searchQuery, setSearchQuery] = useState('');
  const [clearSearchQuery, setClearSearchQuery] = useState(false);

  const [limit, setLimit] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const formatDateToISO = date => date.toISOString();

  const getFirstDayOfWeek = date => {
    const firstDay = new Date(date);
    firstDay.setDate(date.getDate() - firstDay.getDay()); // Sunday is the first day of the week
    firstDay.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDay);
  };

  const getFirstDayOfMonth = date => {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    firstDay.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDay);
  };

  const getFirstDayOfLastMonth = date => {
    const firstDayOfLastMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    firstDayOfLastMonth.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDayOfLastMonth);
  };

  const getLastDayOfLastMonth = date => {
    const lastDayOfLastMonth = new Date(date.getFullYear(), date.getMonth(), 0);
    lastDayOfLastMonth.setHours(23, 59, 59, 999);
    return formatDateToISO(lastDayOfLastMonth);
  };

  const getDateDaysAgo = (date, days) => {
    const result = new Date(date);
    result.setDate(date.getDate() - days);
    result.setHours(0, 0, 0, 0);
    return formatDateToISO(result);
  };
  const fetchData = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);

    let categoryFilter = '';
    if (selectedCategory.length > 0) {
      const categoryFilterString = selectedCategory
        .map(cat => `filters[CategoryCode][$eq]=${cat}`)
        .join('&');
      categoryFilter = `&${categoryFilterString}`;
    }
    let protypeFilter = '';
    if (selectedProductType.length > 0) {
      const protypeFilterString = selectedProductType
        .map(pro => `filters[ProductTypeCode][$eq]=${pro}`)
        .join('&');
      protypeFilter = `&${protypeFilterString}`;
    }
    let colorFilter = '';
    if (selectedColor.length > 0) {
      const colorFilterString = selectedColor
        .map(color => `filters[ColorCode][$eq]=${color}`)
        .join('&');
      colorFilter = `&${colorFilterString}`;
    }
    let finishFilter = '';
    if (selectedFinish.length > 0) {
      const finishFilterString = selectedFinish
        .map(finish => `filters[FinishCode][$eq]=${finish}`)
        .join('&');
      finishFilter = `&${finishFilterString}`;
    }
    let hsnFilter = '';
    if (selectedhsn.length > 0) {
      const hsnFilterString = selectedhsn.map(hsn => `filters[HSNCode][$eq]=${hsn}`).join('&');
      hsnFilter = `&${hsnFilterString}`;
    }
    let matFilter = '';
    if (selectedmaterial.length > 0) {
      const matFilterString = selectedmaterial
        .map(mat => `filters[ProductionDetail][MaterialCode][$eq]=${mat}`)
        .join('&');
      matFilter = `&${matFilterString}`;
    }
    let buyerFilter = '';
    if (selectedBuyer.length > 0) {
      const buyerFilterString = selectedBuyer
        .map(buyer => `filters[BuyerName][$eq]=${buyer}`)
        .join('&');
      buyerFilter = `&${buyerFilterString}`;
    }
    let searchFilter = '';
    if (selectedSearch.length > 0) {
      const SearchFilterString = selectedSearch
        .map(search => `filters[SearchKeyword][$eq]=${search}`)
        .join('&');
      searchFilter = `&${SearchFilterString}`;
    }
    let aliasFilter = '';
    if (selectedAlias.length > 0) {
      const aliasFilterString = selectedAlias
        .map(alias => `filters[ProductId][$eq]=${alias}`)
        .join('&');
      aliasFilter = `&${aliasFilterString}`;
    }
    let pronFilter = '';
    if (selectedpron.length > 0) {
      const pronFilterString = selectedpron
        .map(pron => `filters[ProductName][$eq]=${pron}`)
        .join('&');
      pronFilter = `&${pronFilterString}`;
    }
    let prodFilter = '';
    if (selectedpd.length > 0) {
      const prodFilterString = selectedpd
        .map(prod => `filters[ProductDesigner][$eq]=${prod}`)
        .join('&');
      prodFilter = `&${prodFilterString}`;
    }
    let madeFilter = '';
    if (selectedmade.length > 0) {
      const madeFilterString = selectedmade.map(made => `filters[MadeBy][$eq]=${made}`).join('&');
      madeFilter = `&${madeFilterString}`;
    }
    let skuFilter = '';
    if (selectedsku.length > 0) {
      const skuFilterString = selectedsku.map(sku => `filters[BuyerSku][$eq]=${sku}`).join('&');
      skuFilter = `&${skuFilterString}`;
    }
    let searchQryFilter = '';
    if (searchQuery.length > 0) {
      let searchQryy = searchQuery.trim();
      const searchQry = `filters[$or][0][ProductId][$containsi]=${searchQryy}&filters[$or][1][ProductName][$containsi]=${searchQryy}`;
      searchQryFilter = `&${searchQry}`;
      //  setCurrentPage(1)
    }
    let datefilter = '';
    let updateddatefilter = '';

    const today = new Date();
    const startOfToday = new Date(today.setHours(0, 0, 0, 0)); // Set time to 00:00:00
    const endOfToday = new Date(); // Current time

    switch (selectedDateRange) {
      case 'Today':
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(
          startOfToday
        )}&filters[createdAt][$lte]=${formatDateToISO(endOfToday)}`;
        break;

      case 'Yesterday':
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        datefilter = `filters[createdAt][$eq]=${formatDateToISO(yesterday)}`;
        break;

      case 'This week':
        datefilter = `filters[createdAt][$gte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'Last week':
        const lastWeekStart = new Date(today);
        lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(
          lastWeekStart
        )}&filters[createdAt][$lte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'This month':
        datefilter = `filters[createdAt][$gte]=${getFirstDayOfMonth(today)}`;
        break;

      case 'Last month':
        datefilter = `filters[createdAt][$gte]=${getFirstDayOfLastMonth(
          today
        )}&filters[createdAt][$lte]=${getLastDayOfLastMonth(today)}`;
        break;

      case 'Last 3 month':
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(today.getMonth() - 3);
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
        break;

      case 'Last 6 month':
        const sixMonthsAgo = new Date(today);
        sixMonthsAgo.setMonth(today.getMonth() - 6);
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
        break;

      default: // Or handle the default case as needed
        datefilter = '';
        break;
    }

    switch (selectedUpdatedDateRange) {
      case 'Today':
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
          startOfToday
        )}&filters[updatedAt][$lte]=${formatDateToISO(endOfToday)}`;
        break;

      case 'Yesterday':
        updateddatefilter = `&filters[updatedAt][$eq]=${getDateDaysAgo(today, 1)}`;
        break;

      case 'This week':
        updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'Last week':
        const lastWeekStart = new Date(today);
        lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
          lastWeekStart
        )}&filters[updatedAt][$lte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'This month':
        updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfMonth(today)}`;
        break;

      case 'Last month':
        updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfLastMonth(
          today
        )}&filters[updatedAt][$lte]=${getLastDayOfLastMonth(today)}`;
        break;

      case 'Last 3 month':
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(today.getMonth() - 3);
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
        break;

      case 'Last 6 month':
        const sixMonthsAgo = new Date(today);
        sixMonthsAgo.setMonth(today.getMonth() - 6);
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
        break;

      default: // Or handle the default case as needed
        updateddatefilter = '';
        break;
    }


    const response = await fetch(
      `${ipp}/api/variant-products?populate=*&sort[0]=id:desc&pagination[page]=${currentPage}${categoryFilter}${protypeFilter}${colorFilter}${finishFilter}${hsnFilter}${matFilter}${buyerFilter}${searchFilter}${aliasFilter}${pronFilter}${prodFilter}${madeFilter}${skuFilter}${searchQryFilter}&${updateddatefilter}&${datefilter}`
    );

    const json = await response.json();
    //**only sort based on product id */
    const sortedData = json.data.sort((a, b) => {
      const dateA = new Date(a.attributes.createdAt);
      const dateB = new Date(b.attributes.createdAt);

      // First, sort by createdAt descending (latest first)
      if (dateB - dateA !== 0) {
        return dateB - dateA;
      }

      // If createdAt is the same, sort by ProductId ascending
      const idA = a.attributes.ProductId.toUpperCase();
      const idB = b.attributes.ProductId.toUpperCase();
      return idA.localeCompare(idB);
    });

    //**First sort based on Created at then product id */
    // const sortedData = json.data.sort((a, b) => {
    //   // 1️⃣ Compare createdAt descending
    //   const dateA = new Date(a.attributes.createdAt);
    //   const dateB = new Date(b.attributes.createdAt);
    //   if (dateB - dateA !== 0) return dateB - dateA;

    //   // 2️⃣ If createdAt is same, sort ProductId ascending
    //   const idA = a.attributes.ProductId.toUpperCase();
    //   const idB = b.attributes.ProductId.toUpperCase();
    //   return idA.localeCompare(idB);
    // });

    setLimit(json.data.length);

    if (currentPage === 1) {
      setData123(sortedData);
    } else {
      setData123(prevData => [...prevData, ...sortedData]);

      SetIsLoadingTableData(false);
    }
    setMeta123(json.meta);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage]);
  useEffect(() => {
    fetchData();
  }, []);
  const [allFetchedData, setAllFetchedData] = useState<RowData[]>([]);

  // Fetch all data initially
  useEffect(() => {
    fetchAllData();
  }, []);
  const fetchAllData = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    const response = await fetch(`${ipp}/api/variant-products?populate=*&pagination[page]=1`);
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ipp}/api/variant-products?populate=*&pagination[page]=${page}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    setAllFetchedData(allData);
    setIsLoading(false);
  };

  const [checkedKeys, setCheckedKeys] = useState<number[]>([]);
  const [showtab, setShowtab] = useState(1);
  const [showDrawer, setShowDrawer] = useState(false);


  const handletab2 = e => {
    setShowtab(e);
    const x = document.getElementById('row');
    const y = document.getElementById('second');
    const dd = document.getElementById('bt');
    const dde = document.getElementById('bte');
    if (y?.click) {
      y.hidden = true;
      dd.style.display = 'block';
      dde.style.display = 'none';
    }
    if (y?.click) {
      x.hidden = false;
      dd.style.display = 'none';
      dde.style.display = 'block';
    }
  };
  const [isActive1, setIsActive1] = useState(false);
  const [isActive2, setIsActive2] = useState(true);

  const handleClick2 = () => {
    handletab2(1);
    setIsActive1(isActive2);
    setIsActive2(true);
  };
  const tooltip1 = <Tooltip>Grid View</Tooltip>;
  const ip = ipp;

  const toaster = useToaster();
  const [selectedCategoryCode, setSelectedCategoryCode] = useState([]);
  const [categorydata, setCategorydata] = useState([]);
  const [isLoadingc, setIsLoadingc] = useState(false);
  useEffect(() => {
    fetchCategory(setCategorydata, isLoadingc, setIsLoadingc, SetIsLoadingTableData, setProgress);
  }, []);

  const [colordata, setColordata] = React.useState([]);
  const [isLoadingcolor, setIsLoadingcolor] = React.useState(false);
  useEffect(() => {
    console.log('colordata', colordata);
  }, [colordata]);
  useEffect(() => {
    fetchColors(setColordata, isLoadingcolor, setIsLoadingcolor);
  }, []);

  const [productypedata, setProductypedata] = useState([]);
  const [isLoadingpro, setIsLoadingpro] = useState(false);
  useEffect(() => {
    if (selectedCategoryCode) {
      fetchProductTypes(
        setProductypedata,
        isLoadingpro,
        selectedCategoryCode,
        setIsLoadingpro,
        selectedCategory
      );
    }
  }, [selectedCategoryCode, selectedCategory]);

  const [finishdata, setFinishdata] = useState([]);
  const [isLoadingfin, setIsLoadingfin] = useState(false);
  useEffect(() => {
    fetchFinishes(setFinishdata, isLoadingfin, setIsLoadingfin);
  }, []);

  const [materialdata, setMaterialdata] = React.useState([]);
  const [isLoadingmat, setIsLoadingmat] = React.useState(false);
  useEffect(() => {
    fetchMaterials(setMaterialdata, isLoadingmat, setIsLoadingmat);
  }, []);

  const [hsndata, setHsndata] = React.useState([]);
  const [isLoadinghsn, setIsLoadinghsn] = React.useState(false);
  useEffect(() => {
    fetchHsn(setHsndata, isLoadinghsn, setIsLoadinghsn);
  }, []);

  const [buyernamedata, setBuyerNamedata] = useState([]);
  const [isLoadingbu, setIsLoadingbu] = useState(false);
  useEffect(() => {
    fetchBuyers(setBuyerNamedata, isLoadingbu, setIsLoadingbu);
  }, []);

  const [searchdata, setSearchdata] = useState([]);
  const [isLoadingse, setIsLoadingse] = useState(false);
  useEffect(() => {
    fetchSearchKeyword(setSearchdata, isLoadingse, setIsLoadingse);
  }, []);

  const [proNamedata, setProdNamedata] = useState([]);
  const [isLoadingpron, setIsLoadingpron] = useState(false);
  useEffect(() => {
    fetchProductName(setProdNamedata, isLoadingpron, setIsLoadingpron);
  }, []);

  const [proDdata, setProdDdata] = useState([]);
  const [isLoadingprod, setIsLoadingprod] = useState(false);
  useEffect(() => {
    fetchProductDesign(setProdDdata, isLoadingprod, setIsLoadingprod);
  }, []);

  const [madedata, setMadedata] = useState([]);
  const [isLoadingmade, setIsLoadingmade] = useState(false);
  useEffect(() => {
    fetchMadeBy(setMadedata, isLoadingmade, setIsLoadingmade);
  }, []);
  const [skudata, setSkudata] = useState([]);
  const [isLoadingsku, setIsLoadinsku] = useState(false);
  useEffect(() => {
    fetchSkuUnique(setSkudata, isLoadingsku, setIsLoadinsku);
  }, []);

  const [aliasdata, setAliasdata] = useState([]);
  const [isLoadingalias, setIsLoadingalias] = useState(false);

  useEffect(() => {
    fetchAlias(setAliasdata, isLoadingalias, setIsLoadingalias, isVariant);
  }, [isVariant]);

  // useEffect for clearing searchQuery
  useEffect(() => {
    if (clearSearchQuery) {
      fetchData();
    }
  }, [clearSearchQuery]);

  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);

  // Debounce effect for searchQuery
  useEffect(() => {
    setCurrentPage(1);
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // Adjust the debounce delay as needed

    return () => clearTimeout(timer); // Cleanup the timeout if searchQuery changes before the delay
  }, [searchQuery]);

  // Effect that triggers on debouncedSearchQuery
  useEffect(() => {
    // console.log('searchQuery', debouncedSearchQuery);
    setPage(1);
    fetchData();
  }, [debouncedSearchQuery]); // This effect now triggers when debouncedSearchQuery changes

  useEffect(() => {
    fetchData();
    setCurrentPage(1);
    setPage(1);
  }, [
    selectedCategory,
    selectedDateRange,
    selectedUpdatedDateRange,
    selectedProductType,
    selectedColor,
    selectedFinish,
    selectedhsn,
    selectedmaterial,
    selectedBuyer,
    selectedSearch,
    selectedAlias,
    selectedpron,
    selectedpd,
    selectedmade,
    selectedsku
  ]);
  const handleFilterChange = (
    filterType,
    value,
    prevValue,
    clearSearchQuery,
    setClearSearchQuery
  ) => {
    const tempsearchq = searchQuery;
    setSearchQuery(''); // Clear the search query first

    const anyOtherFilterSelected =
      selectedCategory.length > 0 ||
      selectedProductType.length > 0 ||
      selectedColor.length > 0 ||
      selectedFinish.length > 0 ||
      selectedhsn.length > 0 ||
      selectedmaterial.length > 0 ||
      selectedBuyer.length > 0 ||
      selectedSearch.length > 0 ||
      selectedAlias.length > 0 ||
      selectedpron.length > 0 ||
      selectedpd.length > 0 ||
      selectedmade.length > 0 ||
      selectedsku.length > 0;

    // Handle setting clearSearchQuery flag
    if (anyOtherFilterSelected || prevValue.length === 0) {
      setClearSearchQuery(true);
    } else {
      setClearSearchQuery(false);
      setSearchQuery(tempsearchq);
    }

    // Set the filter state for the specific filter type
    switch (filterType) {
      case 'category':
        setSelectedCategory(value);
        break;
      case 'productType':
        setSelectedProductType(value);
        break;
      case 'color':
        setSelectedColor(value);
        break;
      case 'finish':
        setSelectedFinish(value);
        break;
      case 'hsn':
        setSelectedhsn(value);
        break;
      case 'material':
        setSelectedmaterial(value);
        break;
      case 'buyer':
        setSelectedBuyer(value);
        break;
      case 'search':
        setSelectedSearch(value);
        break;
      case 'alias':
        setSelectedAlias(value);
        break;
      case 'productName':
        setSelectedPron(value);
        break;
      case 'productDescription':
        setSelectedProd(value);
        break;
      case 'made':
        setSelectedMade(value);
        break;
      case 'sku':
        setSelectedSku(value);
        break;
      default:
        break;
    }

    // Reset pagination
    setPage(1);
    setCurrentPage(1);

    // Refetch data only after search query is cleared
    setReload(prev => !prev);
  };

  // Update individual handlers
  const handleCategoryChange = value => {
    handleFilterChange('category', value, selectedCategory, clearSearchQuery, setClearSearchQuery);
  };
  const handleProductTypeChange = value => {
    handleFilterChange(
      'productType',
      value,
      selectedProductType,
      clearSearchQuery,
      setClearSearchQuery
    );
  };
  const handleColorChange = value => {
    handleFilterChange('color', value, selectedColor, clearSearchQuery, setClearSearchQuery);
  };
  const handleFinishChange = value => {
    handleFilterChange('finish', value, selectedFinish, clearSearchQuery, setClearSearchQuery);
  };
  const handleHSNChange = value => {
    handleFilterChange('hsn', value, selectedhsn, clearSearchQuery, setClearSearchQuery);
  };
  const handleMaterialChange = value => {
    handleFilterChange('material', value, selectedmaterial, clearSearchQuery, setClearSearchQuery);
  };
  const handleBuyerChange = value => {
    handleFilterChange('buyer', value, selectedBuyer, clearSearchQuery, setClearSearchQuery);
  };
  const handleSearchChange = value => {
    handleFilterChange('search', value, selectedSearch, clearSearchQuery, setClearSearchQuery);
  };
  const handleAliasChange = value => {
    handleFilterChange('alias', value, selectedAlias, clearSearchQuery, setClearSearchQuery);
  };
  const handleProNameChange = value => {
    handleFilterChange('productName', value, selectedpron, clearSearchQuery, setClearSearchQuery);
  };
  const handleProDChange = value => {
    handleFilterChange(
      'productDescription',
      value,
      selectedpd,
      clearSearchQuery,
      setClearSearchQuery
    );
  };
  const handleMadeChange = value => {
    handleFilterChange('made', value, selectedmade, clearSearchQuery, setClearSearchQuery);
  };
  const handleSkuChange = value => {
    handleFilterChange('sku', value, selectedsku, clearSearchQuery, setClearSearchQuery);
  };

  const [hoveredImage, setHoveredImage] = useState(null);

  const history = useNavigate();

  const fetchPtype = async () => {
    let categoryFilter = '';
    if (selectedCategory.length > 0) {
      const categoryFilterString = selectedCategory
        .map(cat => `filters[Categorycode][$eq]=${cat}`)
        .join('&');
      categoryFilter = `&${categoryFilterString}`;
    }

    try {
      const response = await fetch(
        `${ip}/api/mstproducttypes?populate=*&pagination[pageSize]=10000&${categoryFilter}&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      console.log('RESPONSE PRODUCT TYPE :', json);

      const allData = [];
      const processedData = json.data.map(item => ({
        label: item.attributes.ProductTypeName,
        value: item.attributes.ProductTypeCode
      }));
      allData.push(...processedData);

      setProductypedata(allData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  useEffect(() => {
    fetchPtype();
  }, selectedCategory);

  const [open1, setOpen1] = React.useState(false);
  const [openPrnt, setOpenPrnt] = React.useState(false);

  const [size1, setSize1] = React.useState();

  const handleClosePrint = () => setOpenPrnt(false);

  const handleClose1 = () => setOpen1(false);

  const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
  const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;

  const [sizeshow, setSizeShow] = useState(false);
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      setSizeShow(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [selectedRowIds, setSelectedRowIds] = React.useState([]);
  const handleSelectAll = (isChecked, data) => {
    if (isChecked) {
      // Select all rows
      const allRowIds = data.map(row => row.id);
      setSelectedRowIds(allRowIds);
    } else {
      // Deselect all
      setSelectedRowIds([]);
    }
  };

  // Function to toggle individual row selection

  const [compact, setCompact] = useState(true);
  const [noData, setNoData] = useState(false);
  const CustomCell = compact ? CompactCell : Cell;
  const CustomHeaderCell = compact ? CompactHeaderCell : HeaderCell;

  const FixedLoader = () => (
    <Loader
      content="Loading..."
      style={{
        display: 'flex',
        justifyContent: 'center',
        position: 'absolute',
        bottom: '0',
        background: '#fff',
        width: '100%',
        padding: '4px 0'
      }}
    />
  );
  const renderMenu = menu => {
    return (
      <>
        {menu}
        {isLoadingse && <FixedLoader />}
      </>
    );
  };
  const renderMenu1 = menu => {
    return (
      <>
        {menu}
        {isLoadingalias && <FixedLoader />}
      </>
    );
  };
  const renderMenu2 = menu => {
    return (
      <>
        {menu}
        {isLoadingpron && <FixedLoader />}
      </>
    );
  };
  const renderMenu3 = menu => {
    return (
      <>
        {menu}
        {isLoadingprod && <FixedLoader />}
      </>
    );
  };
  const renderMenu4 = menu => {
    return (
      <>
        {menu}
        {isLoadingmade && <FixedLoader />}
      </>
    );
  };
  const renderMenu5 = menu => {
    return (
      <>
        {menu}
        {isLoadingsku && <FixedLoader />}
      </>
    );
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional - adds smooth scroll animation
    });
  };

  useEffect(() => {
    if (inView && limit) {
      setCurrentPage(prev => prev + 1);
      console.log('Current Page change :', currentPage, 'Now : 1');

      SetIsLoadingTableData(true);
    }
  }, [inView]);
  const [dataGrid, setDataGrid] = useState(6);
  const dataaaaa = [
    { label: 'Extra Small', value: 3 },
    { label: 'Small', value: 4 },
    { label: 'Medium', value: 6 },
    { label: 'Large', value: 8 },
    { label: 'Extra Large', value: 12 }
  ];
  const [openMenuBar, setOpenMenuBar] = useState(false);
  const [productUpdate, setProductUpdate] = useState(false);
  const updatachange = () => {
    setProductUpdate(!productUpdate);
  };

  //  const handleContextMenu = (e) => {
  //     e.preventDefault();
  //   };

  const handleContextMenu = (event, imageUrl) => {
    event.preventDefault();

    if (event.type === 'contextmenu' && event.target.tagName === 'IMG') {
      downloadImage(imageUrl);
    }
  };

  // if (event.type === 'contextmenu' && event.target.tagName === 'IMG') {

  //   if (confirm('Do you want to download this image?')) {
  //     supportsWebP().then(supported => {
  //       if (supported) {
  //         downloadImage(imageUrl);
  //       } else {
  //         alert('Your browser does not support WebP format.');
  //       }
  //     });
  //   }
  // }
  // };
  const applyFilters = () => {
    let filteredProducts = data123;

    if (selectedCategory.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedCategory.includes(item.attributes.CategoryCode)
      );
    }

    if (selectedProductType.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedProductType.includes(item.attributes.ProductTypeCode)
      );
    }

    if (selectedColor.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedColor.includes(item.attributes.ColorCode)
      );
    }

    if (selectedFinish.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedFinish.includes(item.attributes.FinishCode)
      );
    }

    if (selectedhsn.length > 0) {
      filteredProducts = filteredProducts.filter(item =>
        selectedhsn.includes(item.attributes.HSNCode)
      );
    }

    if (selectedmaterial.length > 0) {
      filteredProducts = filteredProducts.filter(item => {
        const materialCode = item.attributes.ProductionDetail[0]?.MaterialCode || '';
        return selectedmaterial.includes(materialCode);
      });
    }

    return filteredProducts;
  };

  const [selectedItems, setSelectedItems] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const handleCheckboxChange = (value, checked) => {
    if (checked) {
      setSelectedItems(prevSelectedItems => [...prevSelectedItems, value]);
    } else {
      setSelectedItems(prevSelectedItems => prevSelectedItems.filter(item => item !== value));
    }
  };

  const handleCheckAll = checked => {
    if (filtersApplied) {
      const filteredProducts = applyFilters();
      setSelectedItems(prevSelectedItems => {
        const mergedItems = new Set([
          ...prevSelectedItems,
          ...(checked ? filteredProducts.map(item => item.id) : [])
        ]);
        return Array.from(mergedItems);
      });
    } else {
      setSelectedItems(checked ? data123.map(item => item.id) : []);
    }
    setIsAllSelected(checked);
  };

  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    if (currentPage == 1 && showModal) {
      setData123([]);
      deleteVari();
      setShowModal(false);
      fetchData();
    }
  }, [currentPage]);
  const handleConfirmDelete = () => {
    // console.log('SELECTED :', selectedItems);
    if (selectedItems.length <= 0) {
      toaster.push(
        <Message showIcon type="error">
          Please Select Variant.
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    }
    if (currentPage > 1) {
      setCurrentPage(1);
    } else {
      setData123([]);
      deleteVari();
      setShowModal(false);
      setSelectedItems([])
      fetchData();
    }
  };
  const openDeleteModal = () => {
    setShowModal(true);
  };
  const closeDeleteModal = () => {
    setShowModal(false);
  };
  async function deleteVari() {
    setLoading(true);
    let data1234 = data123;

    // Iterate over each selected variant ID
    for (const variantId of selectedItems) {
      // Find all matching variants with the current variantId
      const matchingVariants = data1234.filter(variant => variant.id === variantId);
      // console.log("Matching variants:", matchingVariants);

      // Ensure at least one matching variant exists before accessing its attributes
      if (matchingVariants.length > 0) {
        const Variant_Id = matchingVariants[0].attributes.Variant_Id;

        // Count how many variants exist with the same Variant_Id
        const variantIdCount = data1234.filter(
          variant => variant.attributes.Variant_Id === Variant_Id
        );

        // console.log('Variant_Id:', Variant_Id);
        // console.log('Count of Variant_Id:', variantIdCount.length);

        // If there are more than one variant, delete the selected variant
        if (variantIdCount.length > 0) {
          const apiUrl = `${ip}/api/variant-products/${variantId}`;
          try {
            const response = await fetch(apiUrl, {
              method: 'DELETE',
              headers: {
                'Content-Type': 'application/json'
              }
            });

            if (response.ok) {
              // console.log(`Variant with ID ${variantId} has been successfully deleted.`);
              const responseData = await response.json();
              // console.log('Response:', responseData);
              data1234 = data1234.filter(variant => variant.id !== variantId);
              toaster.push(
                <Message showIcon type="success">
                  Variant <b>{responseData.data.attributes.ProductName}</b> successfully deleted.
                </Message>,
                { placement: 'topEnd' }
              );
              setSelectedItems([]);       // clear selected items
              // Remove the deleted variant from the data123 state
            } else {
              console.error(
                `Failed to delete variant with ID ${variantId}. Status: ${response.status}`
              );
              const errorData = await response.json();
              console.error('Error Response:', errorData);
            }
            // window.location.reload();
          } catch (error) {
            console.error('An error occurred while deleting the variant:', error);
          }
        }

        // Filter the product by ProductCode (using Variant_Id)
        const productApiUrl = `${ip}/api/products?populate=*&filters[ProductCode][$eq]=${Variant_Id}`;
        try {
          const response = await fetch(productApiUrl, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          });

          if (response.ok) {
            const productData = await response.json();
            const productId = productData.data[0]?.id; // Get the product ID from the response

            if (productId && variantIdCount.length === 1) {
              // Set Variant to false in the product using its ID
              const productUpdateUrl = `${ip}/api/products/${productId}`;
              const formData = new FormData();
              formData.append(
                'data',
                JSON.stringify({
                  Variant: false // Update the variant field to false
                })
              );

              const updateResponse = await fetch(productUpdateUrl, {
                method: 'PUT',
                body: formData
              });

              if (updateResponse.ok) {
                console.log(
                  `Product with ProductCode ${Variant_Id} has been updated to set Variant = false.`
                );
                const updateResponseData = await updateResponse.json();
                console.log('Response:', updateResponseData);
              } else {
                console.error(
                  `Failed to update product with ProductCode ${Variant_Id}. Status: ${updateResponse.status}`
                );
                const errorData = await updateResponse.json();
                console.error('Error Response:', errorData);
              }
            } else {
              console.log(`No product found with ProductCode ${Variant_Id}`);
            }
          } else {
            console.error(
              `Failed to fetch product with ProductCode ${Variant_Id}. Status: ${response.status}`
            );
            const errorData = await response.json();
            console.error('Error Response:', errorData);
          }
        } catch (error) {
          console.error('An error occurred while fetching or updating the product:', error);
        }
      } else {
        console.log(`No matching variants found for variant ID: ${variantId}`);
      }
    }
    setSelectedItems([]);       // clear selected items
    setLoading(false);
    fetchData();
  }

  const downloadImage = imageUrl => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = function () {
      canvas.width = image.width;
      canvas.height = image.height;
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(blob => {
        const webpUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = webpUrl;
        link.download = 'image.webp';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(webpUrl);
      }, 'image/webp');
    };
    image.src = imageUrl;
  };

  // const supportsWebP = () => {
  //   return new Promise(resolve => {
  //     const image = new Image();
  //     image.onload = () => {
  //       resolve(image.width > 0 && image.height > 0);
  //     };
  //     image.onerror = () => {
  //       resolve(false);
  //     };
  //     image.src =
  //       'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
  //   });
  // };

  const [head, setHead] = useState([]);
  useEffect(() => {
    fetchDataHeads();
  }, []);
  const fetchDataHeads = async () => {
    try {
      const response = await fetch(`${ip}/api/mstfilters?populate=*`);
      const json = await response.json();
      const filteredData = json.data.map(item => ({
        FilterName: item.attributes.FilterName,
        filterstatus: item.attributes.filterstatus
      }));
      setHead(filteredData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  ////////////////////--------PRINT FORMAT CODE START------------////////////////////////////
  const [selectedFormat, setSelectedFormat] = useState(null);
  const [maindata, setMainData] = useState([]);
  const [maindataexcel, setMainDataExcel] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [productName, setProductName] = useState(false);
  const [productSellingPrice, setProductSellingPrice] = useState(false);
  const [productBuyerSku, setProductBuyerSku] = useState(false);
  const [productBuyerName, setProductBuyerName] = useState(false);
  const [productHSNCode, setProductHSNCode] = useState(false);
  const [productMOQ, setProductMOQ] = useState(false);
  const [productGrossWeight, setProductGrossWeight] = useState(false);
  const [productNetWeight, setProductNetWeight] = useState(false);
  const [productPTypeName, setProductPTypeName] = useState(false);
  const [productPCode, setProductPCode] = useState(false);
  const [productCategoryName, setProductCategoryName] = useState(false);
  const [productProductId, setProductProductId] = useState(false);
  const [productDescription, setProductDescription] = useState(false);
  const [productSizeUnit, setProductSizeUnit] = useState(false);
  const [productCbm, setProductCbm] = useState(false);
  const [productColorName, setProductColorName] = useState(false);
  const [productFinishName, setProductFinishName] = useState(false);
  const [openAttri, setOpenAttri] = useState(false);
  const [openAttri2, setOpenAttri2] = useState(false);
  const [cata, setCata] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [catapdf, setCataPdf] = useState([]);
  const [companytype, setCompanytype] = useState('');
  const [inputNumber, setInputNumber] = useState('');
  const [print, setPrint] = useState(false);

  const productLabel: {
    attributes: {
      ProductName: string;
      CategoryName: string;
      ProductCode: string;
      ProductTypeName: string;
      NetWeight: string;
      GrossWeight: string;
      MOQ: string;
      HSNCode: string;
      BuyerName: string;
      BuyerSku: string;
      ColorName: string;
      SellingPrice: string;
      FinishName: string;
      ProductId: string;
      Description: string;
      cbm: string;
      SizeUnit: string;
    };
  }[] = [
      {
        attributes: {
          ProductName: 'Product Name',
          ColorName: 'Color Name',
          FinishName: 'Finish Name',
          ProductId: 'Alias Code',
          Description: 'Description',
          cbm: 'cbm',
          SizeUnit: 'SizeUnit',
          CategoryName: 'Category',
          ProductCode: 'Product Code',
          ProductTypeName: 'Product Type',
          NetWeight: 'Net Weight',
          GrossWeight: 'Gross Weight',
          MOQ: 'MOQ',
          HSNCode: 'HSN Code',
          BuyerName: 'Buyer Name',
          BuyerSku: 'Buyer Sku',
          SellingPrice: 'Sale Price'
        }
      }
    ];

  const options = [
    { label: 'Excel', value: '1' },
    { label: 'PDF 1', value: '2' },
    { label: 'PDF 2', value: '3' },
    { label: 'PDF 3', value: '6' },
    { label: 'QR Code1', value: '4' },
    { label: 'QR Code2', value: '5' }
  ];

  // const handleRowSelection = (id) => {
  //   setSelectedRowIds((prev) =>
  //     prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
  //   );
  // };

  //////--------Excel Generate Start-------------//////////

  useEffect(() => {
    if (
      productName &&
      productProductId &&
      productDescription &&
      productSizeUnit &&
      productCbm &&
      productSellingPrice &&
      productBuyerSku &&
      productBuyerName &&
      productHSNCode &&
      productMOQ &&
      productGrossWeight &&
      productNetWeight &&
      productPTypeName &&
      productPCode &&
      productCategoryName &&
      productFinishName &&
      productColorName
    ) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [
    productName,
    productProductId,
    productDescription,
    productSizeUnit,
    productCbm,
    productFinishName,
    productColorName,
    productSellingPrice,
    productBuyerSku,
    productBuyerName,
    productHSNCode,
    productMOQ,
    productGrossWeight,
    productNetWeight,
    productPTypeName,
    productPCode,
    productCategoryName
  ]);

  const csvData = cata.map(item => {
    const { id, attributes } = item;
    const {
      MaterialCollection,
      ProductionDetail,
      MultipleImage,
      CoverImage,
      Packaging,
      FortyHQ,
      FortyFT,
      TwentyFT,
      Total_CBM,
      publishedAt,
      updatedAt,
      createdAt,
      BuyerSku,
      BuyerName,
      ProductTypeCode,
      MadeBy,
      ProductDesigner,
      MOQ,
      SearchKeyword,
      ProductCost,
      HSNCode,
      ColorCode,
      FinishCode,
      ProductCode,
      CategoryCode,
      Total_CFT,
      ...restAttributes
    } = attributes;
    const imageUrl = `${ip}${attributes.CoverImage?.data?.attributes?.url || ''}`;
    return {
      id,
      Image: imageUrl,
      ...restAttributes
    };
  });
  useEffect(() => {
    fetchDatacd();
  }, []);
  const fetchDatacd = async () => {
    const response = await fetch(`${ip}/api/company-details?populate=*`);
    const json = await response.json();
    setData1(json.data);
  };

  //////--------Excel Generate End-------------//////////
  //////--------PDF1 Generate Start-------------//////////

  useEffect(() => {
    fetchcatappt();
  }, []);
  const fetchcatappt = async () => {
    const response = await fetch(`${ip}/api/company-details?populate=*`);
    const json = await response.json();
    setData2(json.data);
    setCompanytype(json.data[0]?.attributes.Type);
  };

  useEffect(() => {
    if (selectedRowIds.length) {
      fetchDataforQR(); // Fetch more data when currentPage changes
    }
  }, [selectedRowIds]);
  const fetchDataforQR = async () => {
    try {
      // Create a filter to exclude multiple product codes
      const excludeProductCodesFilter = selectedRowIds
        .map(code => `filters[id][$eq]=${code}`)
        .join('&');
      // Fetch data with the filter
      const apiUrl = `${globalIP}/api/variant-products?${excludeProductCodesFilter}&populate=*&pagination[page]=1`;
      const response = await fetch(apiUrl);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/variant-products?${excludeProductCodesFilter}&populate=*&pagination[page]=${page}`
        );
        const pageJson = await pageResponse.json();
        allData.push(...pageJson.data);
      }
      const productData = allData.map(item => ({
        code: item.attributes.ProductId,
        name: item.attributes.ProductName,
        size: `${item.attributes.Length}x${item.attributes.Width}x${item.attributes.Height} ${item.attributes.SizeUnit}`,
        pcode: item.attributes.ProductCode,
        image: item.attributes.CoverImage.data.attributes.url,
        grwt: item.attributes.GrossWeight,
        ntwt: item.attributes.NetWeight
      }));
      setMainData(productData);
      setMainDataExcel(allData);
    } catch (error) {
      console.error('Error fetching product data:', error);
    }
  };

  const [tableHeight, setTableHeight] = useState(20); // Default height

  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 320; // Adjust based on your header/footer size
      const footerHeight = 5; // Adjust based on your footer size
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };

    calculateHeight();
    window.addEventListener('resize', calculateHeight); // Recalculate on window resize

    return () => window.removeEventListener('resize', calculateHeight);
  }, []);
  useFilter(
    selectedCategory,
    selectedProductType,
    selectedColor,
    selectedFinish,
    selectedAlias,
    setAliasdata,
    setFinishdata,
    setColordata,
    setCategorydata,
    setProductypedata
  );
  const items = [
    { key: "content1", label: "All Products" },
    { key: "content2", label: label[0]?.attributes?.Collection },
    { key: "content3", label: "Image Edit" },
    { key: "content4", label: "Variant Products" },
    { key: "content5", label: "Space Visualization" },
  ];
  return (
    <>
      <LoadingBar color="#3498ff" progress={progress} onLoaderFinished={() => setProgress(0)} />

      <>
        <div
          style={{
            justifyContent: 'space-between',
            width: '-webkit-fill-available',
            position: 'fixed',
            height: '180px',
            background: '#fff',
            zIndex: 1
          }}
        >
          <div className="table-toolbar product-head" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>

            {/* LEFT TITLE + BREADCRUMB */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
              {/* Left side: Menu + Breadcrumb */}
              <div className="product-det" style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', gap: '20px' }}>
                  <div onClick={() => setOpenMenuBar(!openMenuBar)}>
                    <MenuIcon className="burgerMenu1" />
                  </div>
                </div>

                <Breadcrumb>
                  <Breadcrumb.Item>
                    <Link to={`/${ugr}/dashboard`}>Home</Link>
                  </Breadcrumb.Item>

                  <Breadcrumb.Item
                    active={activeKey === 'content1'}
                    onClick={() => handleNavSelect('content1')}
                  >
                    Product
                  </Breadcrumb.Item>

                  <Breadcrumb.Item
                    active={activeKey === 'content4'}
                    onClick={() => handleNavSelect('content4')}
                  >
                    Variant Products
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>
              {/* Right side: Select All + Trash */}
              {(user.PRDDelete || user.Category === 'Admin') && (
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                  <Checkbox
                    checked={isAllSelected}
                    onChange={(_, checked) => handleCheckAll(checked)}
                  >
                    Select All
                  </Checkbox>

                  <TrashIcon
                    onClick={selectedItems.length > 0 ? openDeleteModal : null}
                    style={{
                      cursor: selectedItems.length > 0 ? "pointer" : "not-allowed",
                      opacity: selectedItems.length > 0 ? 1 : 0.4,
                      fontSize: "22px"
                    }}
                  />
                </div>
              )}
            </div>

            {/* 🔥 MAIN ROW: FILTERS (left) + TOOLS + DELETE (right) */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: '50px', marginTop: '10px' }}>
              {/* LEFT SIDE: ALL FILTERS */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <HeaderFilter
                  {...{
                    head,
                    label,
                    categorydata,
                    productypedata,
                    colordata,
                    proNamedata,
                    skudata,
                    buyernamedata,
                    finishdata,
                    aliasdata,
                    searchdata,
                    proDdata,
                    madedata,
                    hsndata,
                    materialdata,
                    setCategorydata,
                    setIsLoadingc,
                    isLoadingc,
                    SetIsLoadingTableData,
                    setProgress,
                    setColordata,
                    isLoadingcolor,
                    setIsLoadingcolor,
                    setFinishdata,
                    isLoadingfin,
                    setIsLoadingfin,
                    setHsndata,
                    isLoadinghsn,
                    setIsLoadinghsn,
                    selectedCategory,
                    selectedProductType,
                    selectedColor,
                    selectedpron,
                    selectedsku,
                    selectedBuyer,
                    selectedFinish,
                    selectedAlias,
                    selectedSearch,
                    selectedpd,
                    selectedmade,
                    selectedhsn,
                    selectedmaterial,
                    selectedDateRange,
                    selectedUpdatedDateRange,
                    handleDatechange,
                    handleUpdatedDatechange,
                    handleCategoryChange,
                    handleProductTypeChange,
                    handleColorChange,
                    handleProNameChange,
                    handleSkuChange,
                    handleBuyerChange,
                    handleFinishChange,
                    handleAliasChange,
                    handleSearchChange,
                    handleProDChange,
                    handleMadeChange,
                    handleHSNChange,
                    handleMaterialChange,
                    fetchCategory,
                    fetchColors,
                    fetchFinishes,
                    fetchProductTypes,
                    fetchAlias,
                    renderMenu2,
                    renderMenu5,
                    renderMenu1,
                    renderMenu,
                    renderMenu3,
                    renderMenu4
                  }}
                />
                <Button
                  appearance="default"
                  active
                  onClick={() => {
                    setShowDrawer(true);
                    setIsVariant(true);
                  }}
                >
                  More Filter
                </Button>

                {/* product count */}
                <div>
                  {(selectedCategory.length ||
                    selectedProductType.length ||
                    selectedColor.length ||
                    selectedFinish.length ||
                    selectedhsn.length ||
                    selectedmaterial.length ||
                    selectedBuyer.length ||
                    selectedSearch.length ||
                    selectedAlias.length ||
                    selectedpron.length ||
                    selectedpd.length ||
                    selectedmade.length ||
                    selectedsku.length) > 0 ? (
                    <b>Total Products: {data123.length}/{meta123.pagination.total}</b>
                  ) : (
                    meta123 && <b>Products: {data123.length}/{meta123.pagination.total}</b>
                  )}
                </div>
              </div>

              {/* RIGHT SIDE: TOOLS */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <IconButton
                  onClick={updatachange}
                  icon={productUpdate ? <CloseIcon /> : <EditIcon />}
                  active
                  id="bte"
                />

                <Dropdown
                  menu={{ items, onClick: ({ key }) => handleNavSelect(key) }}
                  trigger={["click"]}
                >
                  <Button>View <EyeFilled /></Button>
                </Dropdown>

                {/* search */}
                <InputGroup inside style={{ width: 200 }}>
                  <Input
                    placeholder="Search"
                    value={searchQuery}
                    onChange={value => setSearchQuery(value)}
                    className="pdt-srch"
                  />
                  <InputGroup.Addon>
                    <SearchIcon style={{ cursor: 'pointer' }} />
                  </InputGroup.Addon>
                </InputGroup>

                {/* grid select */}
                {isActive2 && (
                  <SelectPicker
                    data={dataaaaa}
                    searchable={false}
                    style={{ width: 100 }}
                    placeholder="Grid"
                    onChange={e => setDataGrid(!e ? 6 : e)}
                  />
                )}

                {/* smart search + grid toggle */}
                <ButtonGroup size="md">
                  <Whisper trigger="hover" speaker={<Tooltip>Smart Search</Tooltip>}>
                    <IconButton
                      icon={<ImageIcon />}
                      className="btn btn-outline-secondary"
                      id="ba"
                      onClick={() => {
                        setSmartSerachModalOpen(true);
                        setStopInfininitescrol(false);
                      }}
                    />
                  </Whisper>

                  <Whisper trigger="hover" speaker={tooltip1}>
                    <IconButton
                      icon={<GridIcon />}
                      active={isActive2}
                      className="btn btn-outline-secondary"
                      onClick={handleClick2}
                      id="bb"
                    />
                  </Whisper>
                </ButtonGroup>
              </div>
            </div>
          </div>

          <Divider className="divide product-dvd" style={{ marginTop: '29px' }} />
        </div>
        {/* <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '100px'
            }}
          >
            <Loader size="md" content="Loading..." style={{ color: 'red' }} />
          </div> */}

        <div className={showtab === 1 ? 'row' : ''} id="row" style={{ marginTop: '168px' }}>
          <Panel className="product-details-pnl">
            <FlexboxGrid justify="start" style={{ textAlign: 'center', marginTop: "20px" }} className="datatbl-img">
              {data123.map(item => (
                <ProductCard
                  {...{
                    item,
                    label,
                    dataGrid,
                    handleCheckboxChange,
                    selectedItems,
                    productUpdate,
                    pid: () => {
                      history(`/${ugr}/products-create?svid=${item.id}`);
                    },
                    showCheckbox: 1, // null means no preference
                    showEditIcon: 1, // null means no preference
                    showQuickView: 0, // null means no preference,
                    page: 'variant'
                  }}
                />
              ))}
            </FlexboxGrid>
          </Panel>

          <Button ref={ref} style={{ visibility: 'hidden' }}></Button>

          {isLoading && <Loader center size="md" speed="fast" content="loading..." />}
          <Stack justifyContent="flex-end">
            <IconButton
              size="sm"
              icon={<SortUpIcon />}
              active
              onClick={scrollToTop}
              style={{
                position: 'fixed',
                top: '90%',
                right: 10,
                transform: 'translateY(-50%)',
                zIndex: 0
              }}
            />
          </Stack>
        </div>
        {/* <Divider className='cstm-product-dvdr' /> */}
        <div className={showtab === 2 ? 'tableform' : ''} id="second" hidden>
          <Panel className="cstm-product-row">
            {(selectedCategory.length > 0 ||
              selectedProductType.length > 0 ||
              selectedColor.length > 0 ||
              selectedFinish.length > 0 ||
              selectedhsn.length > 0 ||
              selectedmaterial.length > 0 ||
              selectedBuyer.length > 0 ||
              selectedSearch.length > 0 ||
              selectedAlias.length > 0 ||
              selectedpron.length > 0 ||
              selectedpd.length > 0 ||
              selectedmade.length > 0 ||
              selectedsku.length > 0) && (
                <b style={{ marginLeft: '6px' }}>
                  Total Products: {data123.length}/{meta123.pagination.total}
                </b>
              )}

            {!searchQuery &&
              selectedCategory.length === 0 &&
              selectedProductType.length === 0 &&
              selectedColor.length === 0 &&
              selectedFinish.length === 0 &&
              selectedhsn.length === 0 &&
              selectedmaterial.length === 0 &&
              meta123 && (
                <b style={{ marginLeft: '6px' }}>Total Products: {meta123.pagination.total}</b>
              )}
          </Panel>
        </div>
      </>


      <FilterDrawer
        {...{
          showDrawer,
          setShowDrawer,
          head,
          label,
          //data states
          categorydata,
          productypedata,
          colordata,
          proNamedata,
          skudata,
          buyernamedata,
          finishdata,
          aliasdata,
          searchdata,
          proDdata,
          madedata,
          hsndata,
          materialdata,
          setCategorydata,
          setIsLoadingc,
          isLoadingc,
          SetIsLoadingTableData,
          setProgress,
          setColordata,
          isLoadingcolor,
          setIsLoadingcolor,
          setFinishdata,
          isLoadingfin,
          setIsLoadingfin,
          setHsndata,
          isLoadinghsn,
          setIsLoadinghsn,
          setMaterialdata,
          isLoadingmat,
          setIsLoadingmat,
          //selectedstates
          selectedCategory,
          selectedProductType,
          selectedColor,
          selectedpron,
          selectedsku,
          selectedBuyer,
          selectedFinish,
          selectedAlias,
          selectedSearch,
          selectedpd,
          selectedmade,
          selectedhsn,
          selectedmaterial,
          //onchangehandlers
          selectedDateRange,
          selectedUpdatedDateRange,


          handleDatechange,
          handleUpdatedDatechange,

          handleCategoryChange,
          handleProductTypeChange,
          handleColorChange,
          handleProNameChange,
          handleSkuChange,
          handleBuyerChange,
          handleFinishChange,
          handleAliasChange,
          handleSearchChange,
          handleProDChange,
          handleMadeChange,
          handleHSNChange,
          handleMaterialChange,
          //onopenfunctions
          fetchCategory,
          fetchColors,
          fetchFinishes,
          fetchProductTypes,
          fetchAlias,
          fetchHsn,
          fetchMaterials,
          //rendermenus
          renderMenu2,
          renderMenu5,
          renderMenu1,
          renderMenu,
          renderMenu3,
          renderMenu4,
        }}
      />
      <Stack justifyContent="flex-end"></Stack>
      <Modal open={showModal} onClose={closeDeleteModal} backdrop="static" size="xs">
        <Modal.Header>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>{'Are you sure you want to delete these products ?'}</Modal.Body>
        <Modal.Footer>
          <Button onClick={closeDeleteModal} appearance="subtle" active>
            No
          </Button>
          <Button onClick={handleConfirmDelete} appearance="primary" color="cyan">
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      <Stack
        className="copyright"
        justifyContent="flex-end"
        spacing={5}
        style={{
          position: 'fixed',
          bottom: '0',
          width: '-webkit-fill-available',
          textAlign: 'center',
          backgroundColor: 'white',
          paddingRight: '16px'
        }}
      >
        <p>© All Right Reserved. Product by </p>
        <p>
          {' '}
          <a href="https://erpdaddy.com/" target="_blank">
            ERPDaddy Software Solution.
          </a>
        </p>
      </Stack>
      {smartSerachModalOpen && (
        <SmartSearchModal
          open={smartSerachModalOpen}
          close={() => setSmartSerachModalOpen(false)}
          setData123={setData123}
          setStopInfininitescrol={setStopInfininitescrol}
          setTableData={setTableData}
        />
      )}
    </>
  );
};
export default DataTable;
